
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import loadMyProfile from "@dana/Store/Data/MyProfile/Handlers/GetMyProfileHandler";
import Zone from "@insite/client-framework/Components/Zone";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationStateDana) => ({
    session: getSession(state),
});

export interface CustomerScorecardPageStyles {
    page?: MobiusPageProps;

}

export const customerScorecardPageStyles: CustomerScorecardPageStyles = {
    page: {
        background: themeBackgrounds.offWhite,
        fullWidth: [true, true, true, true, true],
    },
};

const mapDispatchToProps = {

    loadCurrentCountries
};

type Props = ResolveThunks<typeof mapDispatchToProps> & PageProps & ReturnType<typeof mapStateToProps>;
const styles = customerScorecardPageStyles;
const CustomerScorecardPage: React.FC<Props> = ({ id, loadCurrentCountries, session }) => {
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {       
        setIsLoading(false);
    }, [session]);


    return (
        <Page {...styles.page}>     
            <LoadingOverlay loading={isLoading} >
                <Zone contentId={id} zoneName="Content" />
            </LoadingOverlay>
        </Page>
    );
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CustomerScorecardPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "MyProfilePage" instead of this constant.
 */
export const CustomerScorecardContext = "CustomerScorecardPage";
